<template>
  <vx-card title="Top-ups" no-shadow>
    <div slot="no-body" class="mt-4">
      <vs-table :data="transactions" class="table-dark-inverted">
        <template slot="thead">
          <vs-th>TYPE</vs-th>
          <vs-th>AMOUNT</vs-th>
          <vs-th>DESCRIPTION</vs-th>
          <vs-th>DATE</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].type">
              <span class="flex items-center px-2 py-1 rounded">
                <div
                  class="h-3 w-3 rounded-full mr-2"
                  :class="[
                    { 'bg-success': data[indextr].type === 'PURCHASE' },
                    { 'bg-warning': data[indextr].type === 'TOPUP' },
                    { 'bg-primary': data[indextr].type === 'REFUND' },
                  ]"
                ></div>
                {{ data[indextr].type }}
              </span>
            </vs-td>
            <vs-td :data="data[indextr].amount">
              {{ data[indextr].amount }}
            </vs-td>
            <vs-td :data="data[indextr].description">
              <span>{{ data[indextr].description }}</span>
            </vs-td>
            <vs-td :data="data[indextr].transactionDate">
              <span>{{ data[indextr].transactionDate }}</span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <Pagination :total="totalPage" v-model="currentPage" />
    </div>
  </vx-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Pagination from '@/components/Pagination';

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      itemsPerPage: 25,
      currentPage: 1,
      pageTotal: 0,
      totalItem: 0,
      totalPage: 0,
    };
  },
  computed: {
    ...mapState({
      user: ({ userManagement }) => userManagement.user,
      transactions: ({ userManagement }) => userManagement.transactions,
    }),
  },
  methods: {
    ...mapActions({
      getUserTransactions: 'userManagement/getUserTransactions',
    }),
  },
  mounted() {
    if (this.user) {
      this.getUserTransactions({
        id: this.user.id,
        page: this.currentPage,
        limit: this.itemsPerPage,
      })
        .then(response => {
          this.currentPage = parseInt(response.headers['x-pagination-page']);
          this.pageTotal = parseInt(response.headers['x-pagination-count']);
          this.totalItem = parseInt(response.headers['x-pagination-total']);
          this.totalPage = parseInt(response.headers['x-pagination-page-count']);
        })
        .catch(err => {
          console.error(err);
        });
    }
  },
  watch: {
    async currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.getUserTransactions({
          id: this.user.id,
          page: this.currentPage,
          limit: this.itemsPerPage,
        });
      }
    },
  },
};
</script>
<style lang="scss"></style>
